export const INOTIFYOPTIONS = {
  duration: 3000,
  position: { x: 'right', y: 'top' },
};

export const QUILLOPTIONS = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }],

  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ font: [] }],

  ['clean'],
];

export const QUILLMINIMAL = [
  [{ header: [1, 2, false] }],
  ['bold', 'italic', 'underline'],
  [
    { list: 'ordered' },
    { list: 'bullet' },
    { indent: '-1' },
    { indent: '+1' },
    'code-block',
  ],
];

export const TITLE_MAXLENGTH = 100;
export const DESCRIPTION_MAXLENGTH = 500;
export const NOTE_TITLE_LIMIT = 25;
export const NOTE_DESCRIPTION_LIMIT = 100;
export const TODO_TITLE_LIMIT = 33;
export const TODO_DESCRIPTION_LIMIT = 100;
export const NOTESUCESS = 'Note was created successfully';
export const TODOSUCESS = 'Task was created successfully';
export const EVENTSUCCESS = 'Event was created successfully';
export const SUCCESSUPDATE = 'data updated successfully';
export const FAILEDMESSAGE = 'Something went wrong';
export const NOCOMPLETEDTASK = 'No Completed Task Yet.';
export const NOIMPORTANTTASK = 'No Marked Important Task Yet.';
export const EMPTYTASK = 'Empty Tasks, Add a new Task!';
export const ITEMSDELETED = 'Item(s) was deleted successfully';
export const LISTDELETECONFIRM =
  'If you delete the list it will be gone forever. Are you sure you want to proceed?';
